import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const TableContainer = styled.div`
  width: 100%;
  overflow: auto; 
  position: relative; // Ensure the wrapper is positioned relative
  //max-height: 500px; // Set a max height for the scrollable area (adjust as needed)
  // margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // just to adjust

  &::-webkit-scrollbar:horizontal {
    display: none;
  }
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px; // Width of the vertical scrollbar
    //height: 4px; // Height of the horizontal scrollbar
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; // Light gray background for the scrollbar track
    border-radius: 4px; // Rounded corners for the track
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d; // Light gray color for the scrollbar thumb
    border-radius: 4px; // Rounded corners for the thumb
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380; // Darker gray color when hovering over the scrollbar thumb
  }

   ${({ showGradient }) =>
    showGradient &&
    `
    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: ${viewSizeCalculator(3)};
        height: 100%;
        background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        // background: linear-gradient(to left, rgb(245, 97, 97), rgba(255, 255, 255, 0));
        pointer-events: none;
        transition: opacity 0.3s ease;
        opacity: 0.7;
      }
  `}
`;

export const Table = styled.table`
  width: ${({ columnCount }) => columnCount < 3 ? "auto" : "100%"};
  border-collapse: collapse;
  table-layout: fixed;
`;

export const TableHead = styled.thead`
  background: #f8f9fa;
  color: #000;
  font-weight: bold;
`;

export const TableBody = styled.tbody`
  background: #fff;
`;

export const TableRow = styled.tr`
  text-align: left;
  transition: all 0.3s ease-in-out;
  &:nth-child(even) {
    background: #fbfcfd;
  }
`;

export const TableCell = styled.td`
  width: ${() => `${viewSizeCalculator(24.5)}`};
  // width: 340px; 
  height: ${() => `${viewSizeCalculator(3.1)}`}; // 3.75rem
  padding: ${() => `${viewSizeCalculator(0.75)} ${viewSizeCalculator(0.938)}`};
  font-weight: 500;
  text-align: left;
  font-size: ${() => `${viewSizeCalculator(0.913)}`}; // 0.813rem
  line-height: ${() => `${viewSizeCalculator(0.938)}`}; // 3.75rem
  color: #333;
  color: ${({ isNegative, isPlaceholder }) => 
    isPlaceholder ? '#333' : isNegative ? '#FF0000' : '#333'};
  // border-bottom: 1px solid #ddd;
  // border-bottom: ${() => `${viewSizeCalculator(0.1)} solid #ddd`};
  vertical-align: center;
  
  transition: all 0.3s ease-in-out;
  &:last-child:not(:first-child) {
    width: ${() => `${viewSizeCalculator(23)}`}; 
    // max-width: ${() => `${viewSizeCalculator(23.5)}`};
  }
`;

export const PlaceholderCell = styled.td`
  width: ${() => `${viewSizeCalculator(24.5)}`};
  height: ${() => `${viewSizeCalculator(3.1)}`}; // 3.75rem
  padding: ${() => `${viewSizeCalculator(0.75)} ${viewSizeCalculator(0.938)}`};
  font-weight: 500;
  text-align: left;
  font-size: ${() => `${viewSizeCalculator(0.913)}`}; // 0.813rem
  line-height: ${() => `${viewSizeCalculator(0.938)}`}; // 3.75rem
  color: #333;
  color: ${({ isNegative, isPlaceholder }) => 
    isPlaceholder ? '#333' : isNegative ? '#FF0000' : '#333'};
  vertical-align: center;

  &:last-child:not(:first-child) {
    width: ${() => `${viewSizeCalculator(22.5)}`}; 
    // max-width: ${() => `${viewSizeCalculator(23.5)}`};
  }
  transition: all 0.3s ease-in-out;
`;

export const HeaderCell = styled(TableCell)`
  font-weight: 600;
  width: ${() => `${viewSizeCalculator(19.5)}`};
  // width: 270px;
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(0.913)}`};
  line-height: ${() => `${viewSizeCalculator(0.938)}`};
  color: #333333;
  // background: #ffffff;
  background: ${(props) => (props.index % 2 === 1 ? "#fbfcfd" : "white")};
  box-sizing: border-box;
  position: sticky;
  left: 0;
  z-index: 9;
  &:nth-child(even) {
    background: #fbfcfd;
  }
//   box-sizing: border-box;
//   // border: 1px solid red;
//   // outline: 1px solid #ddd;
//   box-sizing: border-box;
// border: 1px solid transparent; /* Transparent border to maintain layout */
// box-shadow: 0 1px 0 0 #ddd; /* Bottom outline effect */

// box-sizing: border-box;
  // border-top: 1px solid transparent; /* Maintain layout */
  // border-bottom: none;
  
  // &::after {
  //   content: "";
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 1px; /* Bottom border thickness */
  //   background-color: #ddd; /* Border color */
  // }
`;

export const AccordionSection = styled.div`
  margin-top: 10px;
`;

export const AccordionHeader = styled.div`
  color: #333333;
  cursor: pointer;
  opacity: 50%;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  line-height: ${() => `${viewSizeCalculator(2.625)}`};
  font-weight: 700;
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.656)}`};

  align-items: center;
  border-radius: 5px;

  // position: sticky;
  top: 0;  
  left: 0; 
  background: white; 
  z-index: 998;
  // border: 1px solid red;
  width: ${({ width }) => `${width}px` || "100%"};
  // width: ${({ width }) => viewSizeCalculator(width / 16) || "100%"};
`;

export const AccordionContent = styled.div`
  background: #fff;
  // padding: 10px;
  // border-radius: 5px;
  // border: 1px solid #ddd;
`;

export const Badge = styled.span`
  width: ${() => `${viewSizeCalculator(4.375)}`};
  height: ${() => `${viewSizeCalculator(1.25)}`};
  padding: ${() =>
    `${viewSizeCalculator(0.5)} ${viewSizeCalculator(1)} ${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`};
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  font-size: ${() => `${viewSizeCalculator(0.825)}`};
  margin-left: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 500;
  color: #fff;
  line-height: ${() => `${viewSizeCalculator(1)}`};
  // background: ${({ type }) =>
    type === "high" ? "#ff4d4d" : type === "medium" ? "#ffcc00" : "#4caf50"};
  // background: #675EF2;
  background: ${(props) => props.bg};

  svg {
    vertical-align: middle;
    margin-top: -2px;
    width: ${() => `${viewSizeCalculator(1)}`};
    height: ${() => `${viewSizeCalculator(1)}`};
  }
`;

export const HospitalAffiliations = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  padding: ${() => `${viewSizeCalculator(0)} ${viewSizeCalculator(0.938)}`};
`;

export const AffiliationItem = styled.li`
  font-size: ${() => `${viewSizeCalculator(0.913)}`};
  line-height: ${() => `${viewSizeCalculator(2)}`};
  font-weight: 500;
  // margin-bottom: 5px;
  color: #333;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
`;

export const Pill = styled.span`
  width: ${() => `${viewSizeCalculator(2.938)}`};
  height: ${() => `${viewSizeCalculator(1.375)}`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
  padding: ${() => `${viewSizeCalculator(0.125)} ${viewSizeCalculator(0.75)}`};
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  line-height: ${() => `${viewSizeCalculator(1.125)}`};
  font-weight: 600;
  text-align: center;
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  color: white;
  background-color: ${(props) => (props.status ? "#61C676" : "#F34D4D")};
`;

export const PillNumber = styled.span`
  min-width: ${() => `${viewSizeCalculator(2.938)}`};
  width: fit-content;
  height: ${() => `${viewSizeCalculator(1.375)}`};
  display: flex;
  flex-direction: column;
  // border: 1px solid red;
  justify-content: center;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
  padding: ${() => `${viewSizeCalculator(0.125)} ${viewSizeCalculator(0.75)}`};
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  line-height: ${() => `${viewSizeCalculator(1.125)}`};
  font-weight: 600;
  text-align: center;
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  color: white;
  // background-color: ${(props) => (props.status ? "#61C676" : "#F34D4D")};
  background: ${(props) => props.bg};
`;

export const ArrowWrapper = styled.div`
  transform: ${({ isActive }) =>
    isActive ? "rotate(0deg)" : "rotate(-90deg)"};
  transition: transform 0.3s ease-in-out;

  position: sticky;
  top: 0;  
  left: 0; 
  background: white; 
  z-index: 998;
  svg {
    width: ${() => `${viewSizeCalculator(0.625)}`};
    height: ${() => `${viewSizeCalculator(0.625)}`};
  }
`;

export const GeographicAccessibility = styled.span`
  margin-left: ${() => `${viewSizeCalculator(0.313)}`};
`;

export const SearchListWrapper = styled.div`
  position: fixed;
  top: ${() => `${viewSizeCalculator(16)}`};
  background: #fff;
  z-index: 9999;
`;

export const SkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
`;

export const WebsiteLink = styled.a`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #e35b42;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #b8442e;
    text-decoration: underline;
  }
`;
